import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeroBanner.css";

const HeroBanner = () => {
  const navigate = useNavigate();

  const handleShopClick = () => {
    navigate("/categories");
  };

  return (
    <div className="hero-banner">
      <div className="banner-content">
        <h1>Новая коллекция "Весна-Лето 2025"</h1>
        <p>Скидки до 40% на первую покупку</p>
        <button className="banner-btn" onClick={handleShopClick}>
          Перейти к покупкам
        </button>
      </div>
    </div>
  );
};

export default HeroBanner;
